import { apiSlice } from './api';
import { ResponseBody } from '../types/common';
import {
  MainDashboardResponse,
  MainRequestBody,
  MainResponse,
  MenuHistory,
  MenuList,
  NotificationList,
  StorageData,
  ViewerHistory,
} from '../types/main';

export const mainApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMain: builder.mutation<MainResponse, MainRequestBody | void>({
      query: (data) => ({
        url: 'library/main',
        method: 'POST',
        body: { data },
      }),
      transformResponse: (res: ResponseBody) => res.data,
    }),
    getStorage: builder.query<StorageData, void>({
      query: () => 'main/storage',
      transformResponse: (res: ResponseBody) => res.data,
      providesTags: ['Main'],
    }),
    getNotifications: builder.query<NotificationList, void>({
      query: () => 'library/main/notifications',
      transformResponse: (res: ResponseBody) => res.data,
    }),
    getMenuList: builder.query<MenuList, void>({
      query: () => 'library/main/menu',
      transformResponse: (res: ResponseBody) => res.data,
    }),
    addMenuHistory: builder.mutation({
      query: (data: MenuHistory) => ({
        url: 'library/main/menu/history',
        method: 'POST',
        body: { data },
      }),
    }),
    addViewerHistory: builder.mutation({
      query: (data: ViewerHistory) => ({
        url: 'library/main/viewer/history',
        method: 'POST',
        body: { data },
      }),
    }),
    getDashboard: builder.query<MainDashboardResponse, number | void>({
      query: (seq) => ({
        url: 'library/analysis/dashboard',
        ...(seq && { params: { seq } }),
      }),
      transformResponse: (res: ResponseBody) => res.data,
    }),
  }),
});

export const {
  useGetMainMutation,
  useGetStorageQuery,
  useGetNotificationsQuery,
  useGetMenuListQuery,
  useAddMenuHistoryMutation,
  useGetDashboardQuery,
} = mainApiSlice;
